import { useState } from "react";
import { Button } from "@/components/ui/button";
import { PlusIcon } from "lucide-react";
import { CreateTagCategoryForm } from "./create-tag-category-form";

export function CreateTagCategoryButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button onClick={() => setOpen(true)}>
        <PlusIcon className="mr-2 h-4 w-4" />
        Create Category
      </Button>
      <CreateTagCategoryForm open={open} onOpenChange={setOpen} />
    </>
  );
}
